(function($, App, Utils, Components) {
	'use strict';

	const logger = new Logger("InputStepper");

	Components.create('InputStepper', {

		Selectors: {
			ButtonIncrease: '[data-input-stepper-increase]',
			ButtonDecrease: '[data-input-stepper-decrease]',
			AttributeIncrease: 'input-stepper-increase',
			AttributeDecrease: 'input-stepper-decrease',
			classNameDisabled: 'is-disabled',
			inputQuantity: '.prize-reservation__input-quantity',
			quantity: '.prize-reservation__quantity',
			Input: '.js-stepper-input',
			inputProductID: '.productId',
			inputPaymentChecked: 'input[name="payment"]:checked',
			modalPayment: '.prize-reservation-modal__payment',
			ButtonSubmit: '.form-submit-button'
		},
		Options: {
			initialValue: 1,
			min: 0,
			max: Infinity
		},

		getValue: function() {
			this.$input.val();
		},

		setValue: function(amount) {
			amount = parseInt(amount, 10) || this.Options.initialValue;

			if (this.amount === parseInt(amount, 10)) return;

			this._setValue(amount);
		},

		_setValue: function(amount) {

			this.amount = (amount !== '') && !isNaN(amount) ? parseInt(amount, 10) : this.Options.initialValue;

			if (this.amount >= this.max) {
				this.amount = parseInt(this.max, 10);
			}

			if (this.amount <= this.min) {
				this.amount = parseInt(this.min, 10);
			}

			this.$input.val(this.amount);
			this.checkState();
		},

		checkState: function() {
			this.amount <= this.min ? this.disableButton(this.$decreaseButton) : this.enableButton(this.$decreaseButton);
			this.amount >= this.max ? this.disableButton(this.$increaseButton) : this.enableButton(this.$increaseButton);
		},

		setMin: function(min) {
			this.min = parseInt(min, 10);
			this._setValue(this.getValue());
		},

		setMax: function(max) {
			this.max = parseInt(max, 10);
			this._setValue(this.getValue());
		},

		increase: function(amount) {
			amount = parseInt(amount);
			if (this.$increaseButton.hasClass(this.Selectors.classNameDisabled)) return;
			const newAmount = parseInt(this.amount + (amount || 1), 10);

			this.setValue(newAmount);
			this.$input.trigger('increase', [amount, this]);
		},

		decrease: function(amount) {
			amount = parseInt(amount);
			if (this.$decreaseButton.hasClass(this.Selectors.classNameDisabled)) return;
			const newAmount = parseInt(this.amount - (amount || 1), 10);

			this.setValue(newAmount);
			this.$input.trigger('decrease', [amount, this]);
		},

		disableButton: function($button) {
			$button.addClass(this.Selectors.classNameDisabled).attr('disabled', true);
			return this;
		},

		enableButton: function($button) {
			$button.removeClass(this.Selectors.classNameDisabled).attr('disabled', false);
		},

		onChange: function(e) {
			if (this.$input.val() === '') {
				this.setValue(this.Options.initialValue);
			} else {
				this.setValue(this.$input.val());
			}
		},
		onKeyDown: function(e) {
			const isEnterKey = e.keyCode == 13;

			if (isEnterKey) {
				this.setValue(this.getValue());
				return e.preventDefault();
			}

			let isSomeKeys = $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1;
			let isMeta = e.metaKey || e.altKey || e.ctrlKey;
			let isHomeEndLeftRight = (e.keyCode >= 35 && e.keyCode <= 39);
			let isUpKey = e.keyCode == 38;
			let isDownKey = e.keyCode == 40;

			if (isUpKey) {
				//this.increase( (e.shiftKey ? 10 : 1) );
				return
			}
			if (isDownKey) {
				//this.decrease( (e.shiftKey ? 10 : 1) );
				return
			}

			if (isSomeKeys || isMeta || isHomeEndLeftRight) return;

			if ((e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
				this.setValue(this.getValue());
			}
			if ((e.shiftKey || ((e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)))) {
				e.preventDefault();
			}
			return this;
		},

		init: function() {
			const _this = this;
			this.$input = $(this.Selectors.Input);
			this.$decreaseButton = $(this.Selectors.ButtonDecrease);
			this.$increaseButton = $(this.Selectors.ButtonIncrease);
			this.$confirmButton = $(this.Selectors.ButtonConfirm);
			this.min = this.$input.attr('min') || this.Options.min;
			this.max = this.$input.attr('max') || this.Options.max;
			this.initialValue = this.getValue() || this.Options.initialValue || this.min;

			this.setValue(this.Options.initialValue, true);
			this.checkState();

			this.$input.on('keydown', this.onKeyDown.bind(this));
			this.$input.on('change', this.onChange.bind(this));

			this.$increaseButton.on('click', function(e) {
				e.preventDefault();
				_this.increase($(this).data(_this.Selectors.AttributeIncrease) || 1);
			});
			this.$decreaseButton.on('click', function(e) {
				e.preventDefault();
				_this.decrease($(this).data(_this.Selectors.AttributeDecrease) || 1);
			});

			document.addEventListener('update.prize-reservation.quantity', function() {
				let $dataBind = $('[data-bind-enable]'),
					$quantity = $(_this.Selectors.quantity),
					$inputQuantity = $(_this.Selectors.inputQuantity),
					$inputProductID = $(_this.Selectors.inputProductID),
					$inputPaymentChecked = $(_this.Selectors.inputPaymentChecked),
					$modalPayment = $(_this.Selectors.modalPayment);

				if ($inputPaymentChecked) {
					let paymentValue = $inputPaymentChecked.val();
					let paymentLabel = $inputPaymentChecked.siblings('label').html();
					if (paymentValue) $inputProductID.val(paymentValue);
					if (paymentLabel) $modalPayment.html(paymentLabel);
				}
				if ($dataBind) Components.BindEnable.init($dataBind);
				if ($quantity) $(_this.Selectors.quantity).text(_this.$input.val());
				if ($inputQuantity) $(_this.Selectors.inputQuantity).val(_this.$input.val());

				// disable submit button
				Utils.disableSubmitButton();


			})

		}

	});

})(jQuery, window.App, window.App.Utils, window.App.Components);
